import orderingImage from "../../../assets/images/featureDiscovery/expandedCarrierScreen/ordering.svg";
import patientTableImage from "../../../assets/images/featureDiscovery/expandedCarrierScreen/patientTable.svg";
import { FeatureDiscoveryTour } from "../types";

export const expandedCarrierScreenTour: FeatureDiscoveryTour = {
  featureKey: "expanded_carrier_screen",
  title: "Expanded Carrier Screen",
  badgeLabel: "New",
  helpTitle: "Expanded Carrier Screen",
  slides: [
    {
      id: "expanded-panels",
      image: orderingImage,
      imageAlt: "Expanded Carrier Screen ordering options",
      body: (
        <>
          <p>
            Carrier Screen with 130- or 611-gene expanded panel options are now
            available!
          </p>
          <p>
            <strong>How it works:</strong> When ordering a new test, you&apos;ll
            now see two additional Carrier Screen options: 130- and 611-gene
            panels.
          </p>
          <p>
            Plus, a new dropdown makes it easier to order Unity Complete with
            preset Aneuploidy and Carrier Screen combinations.
          </p>
        </>
      ),
    },
    {
      id: "patient-table-caption",
      image: patientTableImage,
      imageAlt: "Patient table showing the selected Carrier panel",
      body: (
        <p>
          On the patient table, each patient&apos;s row will now display a
          caption showing which Carrier panel was selected — so you can see at a
          glance whether a patient ordered the 5-gene, 130-gene, or 611-gene
          screen.
        </p>
      ),
    },
  ],
};
